import { ArrowUpRight, FolderGit2 } from 'lucide-react';
import type { Project } from '../api/types';

interface ProjectCardProps {
  project: Project;
}

export default function ProjectCard({ project }: ProjectCardProps) {
  const card = (
    <article className="project-card">
      <div className="project-card-head">
        <span className="project-card-icon" aria-hidden="true">
          <FolderGit2 size={19} />
        </span>
        <h3 className="project-card-name">{project.name}</h3>
      </div>
      {project.description && <p className="project-card-desc">{project.description}</p>}
      <div className="project-card-foot">
        <div className="tag-row">
          {project.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="tag">
              {tag}
            </span>
          ))}
        </div>
        {project.url && (
          <span className="project-card-link">
            访问
            <ArrowUpRight size={14} aria-hidden="true" />
          </span>
        )}
      </div>
    </article>
  );

  if (project.url) {
    return (
      <a
        href={project.url}
        target="_blank"
        rel="noopener noreferrer"
        className="project-card-link-wrapper"
      >
        {card}
      </a>
    );
  }
  return card;
}
